import React, { useEffect, useRef, useState } from 'react';
import { GetModuleListAPI } from '../../services';
import { useSelector } from 'react-redux';
import { LanguageLoader } from '../../assets/languages';
import Modal from './Modal';
import Table from './Table';

const Relate = ({vardef, defaultValue, onChange, forceUpdate}) =>
{
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [firstLoad, SetFirstLoad] = useState(true);
	const [id, SetID] = useState('');
	const [name, SetName] = useState('');
	const [data, SetData] = useState([]);
	const [searchData, SetSearchData] = useState([]);
	const [emptyAlert, SetEmptyAlert] = useState(false);
	const [loader, SetLoader] = useState(false);
	const searchDebounceTimer = useRef(null);
	const minimumCharacter = 0;
	const columns = settings.relate_table_column[vardef.module] ? settings.relate_table_column[vardef.module] : ['name'];
	const tableColumns = columns.reduce((column, item) => ({ ...column, [item]: language.FIELDS[item.toUpperCase()]}), {}) 

	const Search = async (module) =>
	{
		let selected_fields = [...columns];
		selected_fields.push('id');
		const data = {
			selected_fields: selected_fields,
			query: '`'+module.toLowerCase()+'`.`name` LIKE "%'+name+'%"',
		}
		const APIResponse = await GetModuleListAPI(module, data);
		if(APIResponse)
		{
			SetSearchData(APIResponse);
		}
	}
	const see_more_string = vardef.see_more ? 
	<Modal handler={<div className='px-2 py-2 text-sm cursor-pointer hover:bg-primary hover:text-secondaryFont border-b border-primaryBorder font-bold' onClick={() => Search(vardef.module)}>{language.SEE_MORE}</div>}  size={{width:'80vw', height: '80vh'}}>
		<div className='flex flex-wrap'>
			<div className="Field_Container">
				<label>{vardef.label[preferences.language]}</label>
				<input type="text" value={name} onChange={(e) => SetName(e.target.value)} />
			</div>
			<div className="Field_Container">
				<button className='btn btn-success mt-6 h-11 w-12 px-0' onClick={() => Search(vardef.module)}><i className='fa fa-search'></i></button>
			</div>
			<Table itemsPerPage={8} header={tableColumns}>
				{searchData.map((item, index) => (
					<tr key={index}>
						{Object.keys(item).map((key, keyIndex) => columns.includes(key) ? <td className='cursor-pointer' key={keyIndex} onClick={() => SetValue(item)}>{item[key]}</td> : null)}
					</tr>
				))}
			</Table>
		</div>
	</Modal> : null;
	
	useEffect(() =>
	{
		if((defaultValue && defaultValue.id && defaultValue.name && firstLoad) || (defaultValue && forceUpdate))
		{
			SetID(defaultValue.id || '');
			SetName(defaultValue.name || '');
			SetFirstLoad(false);
		}
	// eslint-disable-next-line
	}, [defaultValue]);

	useEffect(() =>
	{
		return () =>
		{
			if(searchDebounceTimer.current)
			{
				clearTimeout(searchDebounceTimer.current);
			}
		}
	}, []);

	const HandleChange = async (value) =>
	{
		if(searchDebounceTimer.current)
		{
			clearTimeout(searchDebounceTimer.current);
			searchDebounceTimer.current = null;
		}
		SetData([]);
		SetName(value);
		let currentID = id;
		if(value.length === 0)
		{
			currentID = '';
			SetID('');
			if(onChange)
			{
				onChange({id:'', name:''});
			}
		}
		if(currentID.length === 0 && (value.length >= minimumCharacter))
		{
			SetLoader(true);
			let queryString = '';
			let queries = [];
			let words = [];
			if(value.indexOf(' ') !== -1)
			{
				words = value.split(' ');
			}
			else
			{
				words.push(value);
			}
			if(words.length)
			{
				if(vardef.module === 'Leads' || vardef.module === 'Contacts' )
				{
					for(const word of words)
					{
						queries.push('CONCAT_WS(" ", '+vardef.module.toLowerCase()+'.first_name,'+vardef.module.toLowerCase()+'.last_name) LIKE "%'+word+'%"');
					}
				}
				else if(vardef.module === 'AOS_Products')
				{
					for(const word of words)
					{
						queries.push('('+vardef.module.toLowerCase()+'.name LIKE "%'+word+'%" OR '+vardef.module.toLowerCase()+'.part_number LIKE "%'+word+'%")');
					}
				}
				else
				{
					for(const word of words)
					{
						queries.push(vardef.module.toLowerCase()+'.name LIKE "%'+word+'%"');
					}
				}
			}
			queryString = queries.length ? '('+queries.join(' AND ')+')' : '';
			const data = {
				selected_fields: ['id', 'name'],
				limit: 5,
				query: queryString,
			}
			await GetModuleListAPI(vardef.module, data).then((APIResponse) => {
				if(APIResponse.length)
				{
					SetData(APIResponse);
				}
				else if(value.length)
				{
					if(onChange)
					{
						onChange({id:'', name:''});
					}
					SetEmptyAlert(true);
				}
				SetLoader(false);
			});
		}
	}

	const HandleSearchChange = (value) =>
	{
		SetName(value);
		if(searchDebounceTimer.current)
		{
			clearTimeout(searchDebounceTimer.current);
		}
		searchDebounceTimer.current = setTimeout(() =>
		{
			HandleChange(value);
		}, 400);
	}

	const SetValue = (item) =>
	{
		if(searchDebounceTimer.current)
		{
			clearTimeout(searchDebounceTimer.current);
			searchDebounceTimer.current = null;
		}
		SetID(item.id);
		SetName(item.name);
		SetData([]);
		SetEmptyAlert(false);
		if(onChange)
		{
			onChange({name:item.name, id:item.id});
		}
	}

	return <>
	{data.length > 0 || emptyAlert ? <div className='absolute w-full left-0 top-0 h-full' onClick={() => {SetData([]); SetEmptyAlert(false); }}></div> : null}
	<div className='relative'>
		<input onChange={(e) => HandleSearchChange(e.target.value)} onClick={() => HandleChange(name)} type='text' className='form-control placeholder:text-xs' value={name} placeholder={minimumCharacter > 0 ? 'برای جستجو حداقل '+minimumCharacter+' کاراکتر وارد نمایید' : null}/>
		{data.length > 0 ?
			<div className='absolute w-full bg-wrapperBG border border-primaryBorder mt-1 rounded shadow' style={{zIndex: 4}}>
				<div className='overflow-y-scroll' style={{scrollbarWidth:'thin'}}>
					{data.map((item, key) =>
						<div key={key} className='px-2 py-2 text-sm cursor-pointer hover:bg-primary hover:text-secondaryFont border-b border-primaryBorder' onClick={() => SetValue(item)}>{item.name}</div>
					)}
				</div>
				{see_more_string}
			</div>
		: null}
		{emptyAlert && !data.length && name.length >= minimumCharacter ?
			<div className='absolute w-full bg-wrapperBG border border-primaryBorder mt-1 rounded shadow' style={{zIndex: 4}}>
				<div className='px-2 py-2 text-sm cursor-pointer hover:bg-primary hover:text-secondaryFont border-b border-primaryBorder'>{language.NO_DATA}</div>
				{see_more_string}
			</div>
		: null}
		</div>
		{loader ?
			<i className='fa fa-spin fa-circle-notch absolute left-3 top-3.5 text-primary'></i>
		: null}
	</>
};

export default Relate;
